var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var initialState = {
    lang: 'en'
};
// Set default language
var language = localStorage.getItem('app-language');
if (language)
    initialState.lang = language;
else
    localStorage.setItem('app-language', 'en');
export var SET_LANGUAGE = "SET_LANGUAGE";
export var languagesReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case SET_LANGUAGE:
            return __assign(__assign({}, state), { lang: action.payload });
        default:
            return state;
    }
};
